<template>
  <div class="datacontent solid-table common_radius">
    <div class="firstrow">
      <span class="label">选择通道</span>
      <el-select v-model="selectHeight" @change="doSelectChannel">
        <el-option
          v-for="item in channelList"
          :label="item.heights"
          :key="item.channelId"
          :value="item.channelId"
        ></el-option>
      </el-select>
    </div>

    <div class="charts_tab">
      <span @click="changeCharts(1)" :class="{ active: activeIndex == 1 }"
        >湍流等级</span
      >
      <span @click="changeCharts(2)" :class="{ active: activeIndex == 2 }"
        >湍流玫瑰图</span
      >
    </div>
    <echart
      v-if="showEcharts"
      :option="levalOption"
      :divStyle="{ with: '99%', height: '500px' }"
      key="levalOption"
    ></echart>
    <div v-if="showEcharts" class="tableDiv">
      <el-table
        class="tableData"
        :data="tableData"
        style="width:100%"
        :header-cell-style="{
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#444455',
          backgroundColor: 'rgb(180, 211, 238)'
        }"
        border
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          prop="speed"
          label="风速(m/s)"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="item"
          label="平均湍流"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="behalfItem"
          label="代表湍流"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="itemPlus"
          label="IEC A+"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="itemA"
          label="IEC A"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="itemB"
          label="IEC B"
          min-width="15%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="itemC"
          label="IEC C"
          min-width="15%"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    <echart
      v-if="showPolarEcharts"
      :option="roseOption"
      :divStyle="{ with: '99%', height: '500px' }"
      key="roseOption"
    ></echart>
  </div>
</template>
<script>
import turbulence from '@/asset/wind-data/turbulence.js';
import isEqual from 'lodash/isEqual';
export default {
  data() {
    return {
      activeIndex: '1',
      selectHeight: '',
      channelList: [],
      showEcharts: true,
      showPolarEcharts: false,
      tableData: [],
      levalOption: {},
      roseOption: {},
      eColor: [
        '#0000ff',
        '#c23531',
        '#00ffff',
        '#61a0a8',
        '#d48265',
        '#91c7ae',
        '#749f83',
        '#ca8622',
        '#bda29a',
        '#6e7074',
        '#546570',
        '#c4ccd3'
      ]
    };
  },
  computed: {
    towerInfo: function() {
      return this.$store.state.WindData.towerObj;
    }
  },
  watch: {
    towerInfo: {
      handler(newVal, oldValue) {
        if (!isEqual(newVal, oldValue)) {
          this.getData(newVal);
        }
      },
      deep: true
    }
  },
  methods: {
    async getRoseData(towerInfo, channelId) {
      let { towerId, versionId } = towerInfo || {};
      if (!towerId && !versionId) return;
      let res2 = await this.$fetch(
        '/winddata/WindAnalyze/getTurbulenceRoseData',
        {
          module: 'windData',
          // showLoading: true,
          params: {
            channelId,
            towerId,
            versionId
          }
        }
      );
      if (res2.code == 0) {
        let turbulenceRoseList = res2.data.turbulenceRoseList;
        let seriesData = [];
        for (let i = 0; i < turbulenceRoseList.length; i++) {
          seriesData.push([turbulenceRoseList[i], i * 22.5]);
        }
        seriesData.push([turbulenceRoseList[0], 0]);
        this.roseOption = {
          title: {
            show: true,
            text: '湍流玫瑰图',
            textStyle: {
              color: '#222233',
              fontFamily: 'FangSong'
            },
            left: 'center'
          },
          angleAxis: {
            type: 'value',
            startAngle: 90,
            boundaryGap: false,
            interval: 22.5,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#222233'
              }
            },
            axisTick: {
              show: true,
              length: 5
            },
            axisLabel: {
              show: true,
              fontSize: 12,
              textStyle: {
                color: '#222233' //这里用参数代替了
              },
              formatter: function(param) {
                return param + '°';
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#222233'
              }
            },
            splitArea: {
              show: false
            },
            axisPointer: {
              show: true,
              label: {
                show: false,
                precision: 1
              }
            }
          },
          radiusAxis: {
            max: function(value) {
              return (value.max * 1.5).toFixed(1);
            },
            axisLine: {
              show: true,
              lineStyle: {
                type: 'solid',
                color: '#222233'
              }
            },
            axisPointer: {
              show: true,
              label: {
                show: false
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#222233'
              }
            }
          },
          polar: {},
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              lineStyle: {
                color: 'transparent'
              },
              crossStyle: {
                type: 'solid',
                color: 'transparent'
              },
              label: {
                color: '#000000',
                backgroundColor: '#ffffff'
              }
            },
            formatter: function(params) {
              //console.log({ params });
              return (
                '角度：' +
                params[0].axisValue +
                '<br>' +
                '值：' +
                seriesData[params[0].dataIndex][0]
              );
            }
          },
          series: [
            {
              type: 'line',
              data: seriesData,
              coordinateSystem: 'polar',
              name: '湍流值 ',
              barWidth: '100%'
            }
          ],
          backgroundColor: '#ffffff'
        };
      }
    },
    doShowLine() {
      this.showEcharts = true;
      this.showPolarEcharts = false;
    },
    async doShowRoseProfile() {
      if (this.selectHeight == '') {
        return this.$message({
          message: '请选择通道',
          type: 'error'
        });
      }
      this.showEcharts = false;
      this.showPolarEcharts = true;
    },
    async getData(towerInfo, channelId, isSearch) {
      let { towerId, versionId } = towerInfo || {};
      if (!towerId && !versionId) return;
      this.tableData = [];
      let res = await this.$fetch(
        '/winddata/WindAnalyze/getTurbulenceStatisticsData',
        {
          module: 'windData',
          // showLoading: true,
          params: {
            channelId: channelId ? channelId : 0,
            towerId,
            versionId
          }
        }
      );
      if (res.code == 0) {
        let resdata = res.data;
        let {
          channelList,
          speedList,
          speedRange,
          turbulenceList,
          behalfTurbulenceList
        } = resdata || {};
        if (!isSearch) {
          this.channelList = channelList;
        }
        let height = '';
        if (channelId) {
          if (this.channelList.length) {
            height = this.channelList.find(v => v.channelId === channelId)
              .heights;
          }
        } else {
          if (this.channelList.length) {
            height = this.channelList[0].heights;
            this.selectHeight = this.channelList[0].channelId;
          }
        }
        let iec3_plus = turbulence['IEC_A+'];
        let iec3a = turbulence.IEC_A;
        let iec3b = turbulence.IEC_B;
        let iec3c = turbulence.IEC_C;

        let turbulenceListData = []; //湍流值改为值类型
        for (let i = 0; i < speedList.length; i++) {
          let item = [speedList[i], turbulenceList[i]];
          turbulenceListData.push(item);
        }
        let behalfTurbulenceListData = []; //代表湍流改为值类型
        for (let i = 0; i < speedList.length; i++) {
          let item = [speedList[i], behalfTurbulenceList[i]];
          behalfTurbulenceListData.push(item);
        }
        let iec3_plusData = []; //改为值类型
        let iec3aData = []; //改为值类型
        let iec3bData = []; //改为值类型
        let iec3cData = []; //改为值类型
        for (let k = 0; k < speedList.length; k++) {
          let item = [speedList[k], iec3_plus[k]];
          iec3_plusData.push(item);
        }
        for (let i = 0; i < speedList.length; i++) {
          let item = [speedList[i], iec3a[i]];
          iec3aData.push(item);
        }
        for (let i = 0; i < speedList.length; i++) {
          let item = [speedList[i], iec3b[i]];
          iec3bData.push(item);
        }
        for (let i = 0; i < speedList.length; i++) {
          let item = [speedList[i], iec3c[i]];
          iec3cData.push(item);
        }

        for (let i = 0; i < speedRange.length; i++) {
          //0和0.5不要，风速从1开始。
          this.tableData.push({
            speed: speedRange[i],
            item: turbulenceList[i],
            behalfItem: behalfTurbulenceList[i],
            itemPlus: iec3_plus[i],
            itemA: iec3a[i],
            itemB: iec3b[i],
            itemC: iec3c[i]
          });
        }
        let levalOption = {
          title: {},
          backgroundColor: '#fff',
          xAxis: {
            name: '风速(m/s)',
            type: 'value',
            min: 0,
            //data: speedList.slice(2),
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: '#222233'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#222233' //这里用参数代替了
              }
            }
          },
          yAxis: {
            name: '湍流强度(%)',
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#222233'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#222233' //这里用参数代替了
              }
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: [height + '代表湍流', 'IEC A+', 'IEC A', 'IEC B', 'IEC C'],
            textStyle: {
              color: '#222233'
            }
          },
          series: [
            {
              name: height + '代表湍流',
              type: 'line',
              data: behalfTurbulenceListData,
              symbol: 'circle',
              symbolSize: 2
            },
            {
              name: 'IEC A+',
              type: 'line',
              data: iec3_plusData,
              symbol: 'circle',
              symbolSize: 2
            },
            {
              name: 'IEC A',
              type: 'line',
              data: iec3aData,
              symbol: 'circle',
              symbolSize: 2
            },
            {
              name: 'IEC B',
              type: 'line',
              data: iec3bData,
              symbol: 'circle',
              symbolSize: 2
            },
            {
              name: 'IEC C',
              type: 'line',
              data: iec3cData,
              symbol: 'circle',
              symbolSize: 2
            }
          ],
          color: this.eColor
        };
        this.levalOption = levalOption;
        //console.log(height)
        //console.log(levalOption, '=====================================');
      }
      this.getRoseData(this.towerInfo, this.selectHeight);
    },
    changeCharts(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;
      if (index == '1') {
        this.doShowLine();
      } else if (index == '2') {
        this.doShowRoseProfile();
      }
    },
    doSelectChannel(val) {
      this.getData(this.towerInfo, val, true);
    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return 'custom-table-row-odd';
      } else {
        return 'custom-table-row-even';
      }
    }
  },
  mounted() {
    this.getData(this.towerInfo);
  }
};
</script>
<style lang="less" scoped>
.eChartContent {
  width: 99%;
  height: 500px;
}

.datacontent {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  background-color: rgb(240, 245, 250);
  .firstrow {
    background: #2f6ba44d;
    padding: 13px 20px 13px 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    .label {
      font-size: 16px;
      font-weight: bold;
      color: #222233;
      margin-right: 10px;
      display: inline-block;
      height: 32px;
      line-height: 32px;
      text-align: right;
      width: 70px;
    }
  }
  .tableDiv {
    width: 100%;
    text-align: center;
  }
}
.charts_tab {
  height: 28px;
  font-size: 0;
  border: 1px solid #0057aaff;
  width: 220px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  overflow: hidden;
  line-height: 26px;
  box-sizing: border-box;
  margin: 20px 0;
  span {
    display: inline-block;
    font-size: 14px;
    color: #0057aaff;
    text-align: center;
    flex: 1;
    height: 100%;
    cursor: pointer;
    &.active {
      color: #fff;
      background: #0057aaff;
      background: linear-gradient(to right, #0878bfff 0%, #0056aaff 100%);
    }
  }
}
</style>
